export const ExecutionStatus = {
    PENDING: 'pending',
    RUNNING: 'running',
    RETRYING: 'retrying',
    COMPLETED: 'completed',
    FAILED: 'failed',
    CANCELLED: 'cancelled',
};
export const ExecutionType = {
    AGENT: 'agent',
    PIPELINE: 'pipeline',
    TOOL: 'tool',
};
export const EXECUTION_STATUSES = Object.values(ExecutionStatus);
export const EXECUTION_TYPES = Object.values(ExecutionType);
//# sourceMappingURL=execution-constants.js.map